export const SET_DATA = 'recipients/setData';
export const SET_QUERY = 'recipients/setQuery';
export const RESET_QUERY = 'recipients/resetQuery';
export const SET_LOADING = 'recipients/setLoading';
